import React from 'react';
import PolicyComponent from "../components/Privacy_Policy"

const PrivacyPolicyPage = props => {
    return (
            <PolicyComponent />
    );
}
export default PrivacyPolicyPage;